<template>
    <div class="vector-lib-container">
        <div class="header">向量库管理</div>

        <el-dialog v-model="showAddDialog" title="添加向量数据" width="600px">
            <el-form :model="form" label-width="80px">
                <el-form-item label="标题">
                    <el-input v-model="form.title" />
                </el-form-item>
                <el-form-item label="内容">
                    <el-input type="textarea" v-model="form.content" rows="4" />
                </el-form-item>
                <el-form-item label="重要性">
                    <el-input-number v-model="form.importance" :min="0" :max="100" />
                </el-form-item>
                <el-form-item label="国家">
                    <el-input v-model="form.country" />
                </el-form-item>
                <el-form-item label="语言">
                    <el-input v-model="form.langName" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showAddDialog = false">取消</el-button>
                <el-button type="primary" @click="submitAdd">确认添加</el-button>
            </template>
        </el-dialog>

        <div class="controls">
            <el-button type="primary" @click="showAddDialog = true">添加数据</el-button>
            <el-divider direction="vertical" />

            <el-input v-model="searchPk" placeholder="按 pk 查询" clearable style="width: 200px" />
            <el-button type="primary" @click="fetchByPk">查询</el-button>
            <el-button @click="resetList">重置</el-button>

            <el-divider direction="vertical" />

            <el-input v-model="searchWords" placeholder="向量搜索关键词" clearable style="width: 200px" />
            <el-input-number v-model="searchK" :min="1" :max="100" style="width: 100px" />
            <el-input v-model="searchExpr" placeholder="过滤条件 expr" clearable style="width: 200px" />
            <el-button type="success" @click="vectorSearch">向量搜索</el-button>
        </div>
        <div class="table-wrapper">
        <el-table :data="vectorList" stripe style="width: 100%; max-height: 500px; overflow-y: auto">
            <!-- <el-table-column prop="pk" label="ID" width="120" /> -->
            <el-table-column prop="title" label="标题" show-overflow-tooltip popper-class="custom-tooltip" />
            <el-table-column prop="abstracts" label="内容" show-overflow-tooltip popper-class="custom-tooltip" />
            <el-table-column prop="importance" label="重要性" width="100" />
            <el-table-column prop="country" label="国家" width="100" />
            <el-table-column prop="langName" label="语言" width="100" />
            <el-table-column prop="sim" label="相关性" width="100">
                <template #default="scope">
                    {{ scope.row.sim ? scope.row.sim : '--' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template #default="scope">
                    <el-button size="small" type="danger" @click="confirmDelete(scope.row.pk)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <div class="pagination">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="totalCount"
                :page-sizes="[25, 50, 100]" :page-size="pageSize" :current-page="currentPage"
                @size-change="handleSizeChange" @current-change="handlePageChange" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElMessageBox, ElMessage } from 'element-plus'

const showAddDialog = ref(false)

const vectorList = ref([])
const searchPk = ref('')
const searchWords = ref('')
const searchK = ref(4)
const searchExpr = ref('')

const currentPage = ref(1)
const pageSize = ref(25)
const totalCount = ref(0)

const form = ref({
    title: '',
    content: '',
    importance: 50,
    country: '',
    langName: ''
})
const submitAdd = async () => {
    try {
        const url = `${process.env.VUE_APP_BASE_URL}/api/rag/add`
        console.log(url)
        await axios.post(url, form.value)
        ElMessage.success('添加成功')
        showAddDialog.value = false
        fetchAll() // 重新刷新列表
    } catch (err) {
        console.error(err)
        ElMessage.error('添加失败')
    }
}

const fetchAll = async () => {
    // const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/rag/find`)
    // vectorList.value = res.data || []

    const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/rag/find`, {
        params: {
            page: currentPage.value,
            pagesize: pageSize.value
        }
    })
    vectorList.value = res.data?.data || []
    totalCount.value = res.data?.total_count || 0
}

const fetchByPk = async () => {
    if (!searchPk.value) return
    const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/rag/find`, { pk: searchPk.value })
    vectorList.value = res.data ? [res.data] : []
}

const resetList = () => {
    fetchAll()
}

const vectorSearch = async () => {
    const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/rag/search`, {
        params: {
            words: searchWords.value,
            key: searchK.value,
            expr: searchExpr.value
        }
    })
    vectorList.value = res.data || []
    currentPage.value = 1
}

const confirmDelete = async (pk) => {
    try {
        await ElMessageBox.confirm(
            '确定要删除这条数据吗？此操作不可撤销。',
            '确认删除',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )

        // 如果点击了“确定”，再调用接口
        await axios.post(`${process.env.VUE_APP_BASE_URL}/api/rag/del`, { pk })
        ElMessage.success('删除成功')
        fetchAll() // 重新加载数据

    } catch (err) {
        if (err !== 'cancel') {
            console.error(err)
            ElMessage.error('删除失败')
        }
        // 如果是取消操作，不做提示
    }
}

const handleSizeChange = (val) => {
  pageSize.value = val
  currentPage.value = 1
  fetchAll()
}

const handlePageChange = (val) => {
  currentPage.value = val
  fetchAll()
}

onMounted(() => {
    fetchAll()
})
</script>

<style scoped>
.vector-lib-container {
    padding: 16px;
    background-color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.header {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 16px;
}

.controls,
.add-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
    align-items: center;
}

.pagination {
    margin-top: 16px;
    display: flex;
    justify-content: center;
}

.two-line-ellipsis .cell {
    max-width: 200px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制两行 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: normal;

}

::v-deep(.custom-tooltip) {
    text-align: left !important;
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 100px;
    /* 可根据需要调整 */
}

</style>